// extracted by mini-css-extract-plugin
export default {"l_BrandInfoSwipeBox_main":"BrandInfoSwipeBox_l_BrandInfoSwipeBox_main__6yu28"};